import { ImportContacts } from '@mui/icons-material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { OptionsButton, PlusIcon, TrainIcon, useMinimalsTheme, VesselIcon } from '@tom-ui/ui'
import { CarrierType } from '@yard/app/api'
import { YARD_DRAWER_HEADER_HEIGHT } from '@yard/pages/YardSetup/helpers/yard-view.utils'
import { observer } from 'mobx-react-lite'

type Props = {
  title: string
  overTitle?: string
  carrierType?: CarrierType
  onCreateNewRule: () => void
  onImportFromLibrary: () => void
  onCopyFromVisit?: () => void
}
export const AllocationRulesDrawerHeader = observer((props: Props) => {
  const { title, overTitle, carrierType, onCreateNewRule, onImportFromLibrary, onCopyFromVisit } =
    props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const options = [
    {
      label: t('createNew', 'Create new'),
      rightIcon: <PlusIcon />,
      onClick: () => onCreateNewRule(),
    },
    {
      label: t('fromLibrary', 'From Library'),
      rightIcon: <ImportContacts />,
      onClick: () => onImportFromLibrary(),
    },
  ]

  if (onCopyFromVisit) {
    options.push({
      label: t('copyFromVisit', 'Copy from visit'),
      rightIcon: <ContentCopyIcon />,
      onClick: () => onCopyFromVisit(),
    })
  }

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      borderBottom={`1px solid ${theme.palette.divider}`}
      p={theme.customSpacing.s}
      height={YARD_DRAWER_HEADER_HEIGHT}
    >
      <Stack direction='column' spacing={0}>
        {overTitle && <Typography variant='mini'>{overTitle}</Typography>}
        <Stack direction='row' spacing={1} alignItems='center'>
          {carrierType === CarrierType.Vessel && <VesselIcon fontSize='small' />}
          {carrierType === CarrierType.Train && <TrainIcon fontSize='small' />}
          <Typography variant='subtitle1'>{title}</Typography>
        </Stack>
      </Stack>
      <OptionsButton position='right' options={options} customIcon={<PlusIcon />} />
    </Stack>
  )
})
